import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "dataEBM",
  initialState: {
    currentDataEBM: null,
    generalDataEBM: null,
    generalDataCO2EBM: null,
    anualDataEBM: null,
    prorrateo2023: null,
    prorrateo2024: null,
    prorrateo2025: null,
    uploadedBills: null,
    uploadedBillsEBM: null,
    billsToReviewEBM: null,

    isFetching: false,
    isFetchingAnualEBM: false,
    isFetchingGeneralDataEBM: false,
    isFetchingGeneralCo2EBM: false,
    isFetchingProrrateo2023: false,
    isFetchingProrrateo2024: false,
    isFetchingProrrateo2025: false,
    isFetchingBillsToReviewEBM: false,
    billFetchingEBM: false,
    error: false,
    errorMessage: null,
  },
  reducers: {
    dataStart: (state) => {
      state.isFetching = true;
    },
    dataSuccess: (state, action) => {
      state.isFetching = false;
      state.currentDataEBM = action.payload;
    },
    dataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    generalDataStart: (state) => {
      state.isFetchingGeneralDataEBM = true;
    },
    generalDataSuccess: (state, action) => {
      state.isFetchingGeneralDataEBM = false;
      state.generalDataEBM = action.payload;
    },
    generalDataFailure: (state, action) => {
      state.isFetchingGeneralDataEBM = false;
      state.generalDataEBM = action.payload;
      state.error = true;
    },
    generalDataStartCO2: (state) => {
      state.isFetchingGeneralCo2EBM = true;
    },
    generalDataSuccessCO2: (state, action) => {
      state.isFetchingGeneralCo2EBM = false;
      state.generalDataCO2EBM = action.payload;
    },
    generalDataFailureCO2: (state, action) => {
      state.isFetchingGeneralCo2EBM = false;
      state.generalDataCO2EBM = action.payload;
      state.error = true;
    },
    anualDataStart: (state) => {
      state.isFetchingAnualEBM = true;
    },
    anualDataSuccess: (state, action) => {
      state.isFetchingAnualEBM = false;
      state.anualDataEBM = action.payload;
    },
    anualDataFailure: (state, action) => {
      state.isFetchingAnualEBM = false;
      state.anualDataEBM = action.payload;
      state.error = true;
    },
    prorrateo2023Start: (state) => {
      state.isFetchingProrrateo2023 = true;
    },
    prorrateo2023Success: (state, action) => {
      state.isFetchingProrrateo2023 = false;
      state.prorrateo2023 = action.payload;
    },
    prorrateo2023Failure: (state, action) => {
      state.isFetchingProrrateo2023 = false;
      state.prorrateo2023 = action.payload;
      state.error = true;
    },
    prorrateo2024Start: (state) => {
      state.isFetchingProrrateo2024 = true;
    },
    prorrateo2024Success: (state, action) => {
      state.isFetchingProrrateo2024 = false;
      state.prorrateo2024 = action.payload;
    },
    prorrateo2024Failure: (state, action) => {
      state.isFetchingProrrateo2024 = false;
      state.prorrateo2024 = action.payload;
      state.error = true;
    },
    prorrateo2025Start: (state) => {
      state.isFetchingProrrateo2025 = true;
    },
    prorrateo2025Success: (state, action) => {
      state.isFetchingProrrateo2025 = false;
      state.prorrateo2025 = action.payload;
    },
    prorrateo2025Failure: (state, action) => {
      state.isFetchingProrrateo2025 = false;
      state.prorrateo2025 = action.payload;
      state.error = true;
    },
    logoutInfoData: (state) => {
      state.currentDataEBM = null;
      state.generalDataEBM = null;
      state.generalDataCO2EBM = null;
      state.anualDataEBM = null;
      state.prorrateo2023 = null;
      state.prorrateo2024 = null;
      state.prorrateo2025 = null;
      state.uploadedBills = null;
      state.uploadedBillsEBM = null;
      state.billsToReviewEBM = null;
      state.isFetching = false;
      state.isFetchingAnualEBM = false;
      state.isFetchingGeneralDataEBM = false;
      state.isFetchingGeneralCo2EBM = false;
      state.isFetchingProrrateo2023 = false;
      state.isFetchingProrrateo2024 = false;
      state.isFetchingProrrateo2025 = false;
      state.isFetchingBillsToReviewEBM = false;
      state.billFetchingEBM = false;
      state.error = false;
      state.errorMessage = null;
    },
    billStart: (state) => {
      state.billFetchingEBM = true;
      state.error = false;
      state.errorMessage = null;
    },
    billSuccess: (state) => {
      state.billFetchingEBM = false;
      state.error = false;
    },
    billFailure: (state, action) => {
      state.billFetchingEBM = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    uploadedBillsStart: (state) => {
      state.isFetching = true;
      state.error = false;
      state.errorMessage = null;
    },
    uploadedBillsSuccess: (state, action) => {
      state.isFetching = false;
      state.uploadedBills = action.payload;
      state.uploadedBillsEBM = action.payload;
      state.error = false;
    },
    uploadedBillsFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    billsToReviewStart: (state) => {
      state.isFetchingBillsToReviewEBM = true;
      state.error = false;
      state.errorMessage = null;
    },
    billsToReviewSuccess: (state, action) => {
      state.isFetchingBillsToReviewEBM = false;
      state.billsToReviewEBM = action.payload;
      state.error = false;
    },
    billsToReviewFailure: (state, action) => {
      state.isFetchingBillsToReviewEBM = false;
      state.error = true;
      state.errorMessage = action.payload;
      state.billsToReviewEBM = [];
    },
    deleteBillsStart: (state) => {
      state.isFetching = true;
      state.error = false;
      state.errorMessage = null;
    },
    deleteBillsSuccess: (state, action) => {
      state.isFetching = false;
      state.uploadedBills = action.payload;
      state.uploadedBillsEBM = action.payload;
      state.error = false;
    },
    deleteBillsFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
  },
});

export const {
  dataStart,
  dataSuccess,
  dataFailure,
  generalDataStart,
  generalDataSuccess,
  generalDataFailure,
  generalDataStartCO2,
  generalDataSuccessCO2,
  generalDataFailureCO2,
  anualDataStart,
  anualDataSuccess,
  anualDataFailure,
  prorrateo2023Start,
  prorrateo2023Success,
  prorrateo2023Failure,
  prorrateo2024Start,
  prorrateo2024Success,
  prorrateo2024Failure,
  prorrateo2025Start,
  prorrateo2025Success,
  prorrateo2025Failure,
  logoutInfoData,
  billStart,
  billSuccess,
  billFailure,
  uploadedBillsStart,
  uploadedBillsSuccess,
  uploadedBillsFailure,
  billsToReviewStart,
  billsToReviewSuccess,
  billsToReviewFailure,
  deleteBillsStart,
  deleteBillsSuccess,
  deleteBillsFailure,
} = dataSlice.actions;

export default dataSlice.reducer;